module.exports = __webpack_public_path__ + "static/media/nutricia-brand-allergens-fish.d1e66b26.svg";